import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Firefox 3.0 release party",
  "description": "",
  "published": "2008-06-26T00:00:00.000Z",
  "redirect_from": ["/blog/firefox-30-release-party/swizec/100"],
  "categories": "intrigues, life",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The `}<a parentName="p" {...{
        "href": "http://www.kiberpipa.org/firefox/",
        "title": "Firefox release event"
      }}>{`firefox 3 release event`}</a>{` happened this Tuesday and I would've blogged about it yesterday were it not for some people's stupid keyboards that I swear were not meant to be typed on.`}</p>
    <p>{`It went on at `}<a parentName="p" {...{
        "href": "http://www.kiberpipa.org/",
        "title": "Kiberpipa"
      }}>{`kiberpipa`}</a>{` and was rather well organised for such an event, was pleasantly surprised. Everything started off with a talk from `}<a parentName="p" {...{
        "href": "http://standblog.org/blog/"
      }}>{`Tristan Nitot`}</a>{` about how Firefox came about and why it's managed to strive so much. He spoke of interesting things I haven't even thought of before, but it was all a bit dragged out if you ask me and it showed that he wasn't very well prepared (in fact he admited to having finished the presentation six minutes after he was scheduled to give it).`}</p>
    <p>{`Unluckily, though, it was a bit too hot for my liking and I didn't want to sweat my life away there so the other presentations escaped me since I went home to have a shower. But I'm certain they were very interesting and informative.`}</p>
    <p>{`Later on I came to the party where I got the rest of my free stuff (all together a t-shirt from the event, firefox wine and a notebook, awesome) and mingled a bit with the people. Didn't know very many of them, but at least the food was bloody awesome. Nice of them to have thought of feeding us ... unlike blogres you know ...`}</p>
    <p>{`When I noticed `}<a parentName="p" {...{
        "href": "http://standblog.org/blog/"
      }}>{`Tristan`}</a>{` was a bit removed from everyone else I went to implore about why Opera wasn't shown on any of the graphs in his presentation and he mentioned that the time has come when FF finally beats Opera in certain performance aspects - interesting stuff, will have to try. Also, interestingly, he also reads xkcd and recognised my t-shirt as being from there.`}</p>
    <p>{`Sadly I left the party after an hour because I was melting my life away.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      